import React, { useEffect } from 'react';
import FilterSearchBar from 'components/shared/FilterSearchBar/index';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormRangePicker from 'components/shared/BWFormControl/FormDateRange';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { mapDataOptions4Select, statusTypesOption } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { offerTypes } from 'pages/PromotionOffers/utils/helpers';
import { getOptionsGlobal } from 'actions/global';

const PromotionOffersFilter = ({ onChange, onClear }) => {
  const dispatch = useDispatch();
  const { companyData, businessData } = useSelector((state) => state.global);
  const methods = useForm({
    defaultValues: {
      is_active: 1,
      company_id: null,
      bussiness_id: null,
    },
  });
  const companyId = useWatch({ control: methods.control, name: 'company_id' });

  useEffect(() => {
    dispatch(getOptionsGlobal('company'));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getOptionsGlobal('business', {
        company_id: companyId,
      }),
    );
  }, [companyId, dispatch]);

  const onSubmit = (values) => {
    const q = {
      search: values.search,
      offer_type: values.offer_type,
      company_id: values.company_id,
      bussiness_id: values.bussiness_id,
      is_active: values.is_active ?? 1,
      create_date_from: values.create_date_from,
      create_date_to: values.create_date_to,
    };
    onChange(q);
  };

  const handleKeyDownSearch = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      methods.handleSubmit(onSubmit)();
    }
  };

  return (
    <FormProvider {...methods}>
      <FilterSearchBar
        title='Tìm kiếm'
        compact
        onSubmit={onSubmit}
        onClear={() => onClear()}
        actions={[
          {
            title: 'Từ khóa',
            component: (
              <FormInput
                field='search'
                placeholder='Nhập tên ưu đãi khuyến mại'
                onKeyDown={handleKeyDownSearch}
              />
            ),
          },
          {
            title: 'Loại ưu đãi',
            component: <FormSelect field='offer_type' list={offerTypes} />,
          },
          {
            title: 'Công ty',
            component: (
              <FormSelect
                field='company_id'
                list={mapDataOptions4Select(companyData ?? [])}
                placeholder='Chọn công ty'
                onChange={() => {
                  methods.setValue('bussiness_id', null, {
                    shouldDirty: false,
                    shouldTouch: false,
                    shouldValidate: false,
                  });
                }}
              />
            ),
          },
          {
            title: 'Chi nhánh',
            component: (
              <FormSelect
                field='bussiness_id'
                list={mapDataOptions4Select(businessData ?? [])}
                placeholder={companyId ? 'Chọn chi nhánh' : 'Chọn công ty trước'}
                disabled={!companyId}
              />
            ),
          },
          {
            title: 'Trạng thái',
            component: <FormSelect field='is_active' list={statusTypesOption} />,
          },
          {
            title: 'Ngày tạo',
            component: (
              <FormRangePicker
                fieldStart={'create_date_from'}
                fieldEnd={'create_date_to'}
                placeholder={['Từ ngày', 'Đến ngày']}
                format={'DD/MM/YYYY'}
                allowClear={true}
              />
            ),
          },
        ]}
      />
    </FormProvider>
  );
};

export default PromotionOffersFilter;
